export default __webpack_public_path__ + "static/for-fabric-suppliers-mobile-fd24ae92bdf70c25f5f7cdbb99ddd487.jpg";